var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.getContent,"placement":"top"}},[_c('i',{staticClass:"label iconfont",class:[_vm.getIcon, _vm.getStatus]})])
}
var staticRenderFns = []

export { render, staticRenderFns }